<script setup lang="ts">
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.TrustedByFeaturesSlice>());
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      class="pa-trust"
  >
    <div class="pa-container">
      <ul class="pa-trust__list">
        <li
            v-for="(feature, index) in slice.primary.features"
            :key="index"
            class="pa-trust__item"
        >
          <div v-if="feature.icon?.url" class="pa-trust__item-icon">
            <PrismicImage :field="feature.icon" />
          </div>
          <div class="pa-trust__item-content">
            <p v-if="feature.title" class="pa-trust__item-title">
              {{ feature.title }}
            </p>
            <p v-if="feature.subtitle" class="pa-trust__item-subtitle">
              {{ feature.subtitle }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
